import 'utils/filter_form';
import 'utils/autofill_by_query_string';
import 'components/alphabetical_input';
import './index.scss';

(function ($) {
  const $filterForm = $('#js-knowledge-areas-filter-form');

  $filterForm
    .autoFillByQueryString()
    .filterForm()
    .lazyReady();

  $('.js-btn-save', $filterForm).on('click', () => {
    console.log('TODO: Save current filters');
    $filterForm.trigger('filterFormToggle');
  });

  // $filterForm.on('submit', () => {
  //   $filterForm.trigger('filterFormToggle');
  //   return false;
  // });
})(jQuery);
